import { render } from "./HorseEditDocumentsGenerate.vue?vue&type=template&id=95f2d28e&scoped=true"
import script from "./HorseEditDocumentsGenerate.vue?vue&type=script&lang=js"
export * from "./HorseEditDocumentsGenerate.vue?vue&type=script&lang=js"

import "./HorseEditDocumentsGenerate.vue?vue&type=style&index=0&id=95f2d28e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95f2d28e"]])

export default __exports__